<template>
  <li>
    <div class="responsive-row header">{{ header }}</div>
    <div>{{ details }}</div>
  </li>
</template>

<script setup lang="ts">
const props = defineProps<{
  header: string;
  details: string;
}>();
</script>

<style scoped src="@/styles/certification-updates/disbursements.css"></style>
